<div *ngIf="showSpinner" class="wrapper">
  <div class="ring">
    <img src="../../../../../assets/images/kmd-logo.svg" />
    <span></span>
  </div>
</div>
